import * as z from 'zod';

const envSchema = z.object({
  VITE_BUILD_VERSION: z.string(),
  VITE_MANAGEMENT_BASE_URL: z.string().optional(),
});

// eslint-disable-next-line no-restricted-syntax
export const ENV = envSchema.parse(import.meta.env);
